import { Component, Inject } from '@angular/core';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

interface IMarketCap {
  min_market_cap: number;
  max_market_cap: number;
}


@Component({
  selector: 'app-mcap-slider',
  standalone: true,
  imports: [
    NgxSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './mcap-slider.component.html',
  styleUrls: ['./mcap-slider.component.css']
})

export class McapSliderComponent {
  min_market_cap: number = 0;
  max_market_cap: number = 0;
  minCapInput: string = '';
  maxCapInput: string = '';
  sliderMin: number = 0;
  sliderMax: number = 0;
  constructor(
    private dialogRef: MatDialogRef<McapSliderComponent>, @Inject(MAT_DIALOG_DATA) public data: IMarketCap
  ) {

    // console.log("The values from the parent:", data);
    this.min_market_cap = data.min_market_cap;
    this.max_market_cap = data.max_market_cap;
    this.minCapInput = this.formatCap(this.min_market_cap)
    this.maxCapInput = this.formatCap(this.max_market_cap)

    this.sliderMin = this.min_market_cap / 1e6;
    this.sliderMax = this.max_market_cap / 1e6;
  }



  // Slider options
  sliderOptions: Options = {
    floor: 0,
    ceil: 5000000 + 10000,// slightly above 5T in millions bcoz the 
    step: 10,
    translate: (value: number): string => {
      if (value === 0) return '0';
      if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}T`;
      if (value >= 1_000) return `${(value / 1_000).toFixed(1)}B`;
      return `${value}M`;
    }

  };

  // Parsing input values
  parseCapValue(val: string): number | null {
    const match = val.toUpperCase().match(/^([\d.]+)\s*([MBT])$/);
    if (!match) return null;
    const num = parseFloat(match[1]);
    if (match[2] === 'B') return num * 1e9;
    if (match[2] === 'T') return num * 1e12;
    return num * 1e6; // For Millions
  }

  // Format value as string with suffix
  formatCap(val: number): string {
    if (val >= 1e12) {
      return `${(val / 1e12).toFixed(1)}T`;
    } else if (val >= 1e9) {
      return `${(val / 1e9).toFixed(1)}B`;
    } else {
      return `${Math.round(val / 1e6)}M`;
    }
  }

  parseMarketCapInputs(): void {
    const parsedMin = this.parseCapValue(this.minCapInput) ?? 0;
    const parsedMax = this.parseCapValue(this.maxCapInput) ?? 10000000000000;

    // Ensure min is less than max
    const [safeMin, safeMax] = parsedMin > parsedMax
      ? [parsedMax, parsedMin]
      : [parsedMin, parsedMax];

    this.min_market_cap = safeMin;
    this.max_market_cap = safeMax;
    this.sliderMin = safeMin / 1e6; // Convert to millions
    this.sliderMax = safeMax / 1e6; // Convert to millions

    this.minCapInput = this.formatCap(safeMin);
    this.maxCapInput = this.formatCap(safeMax);
  }

  onSliderChange(): void {
    if (this.sliderMin > this.sliderMax) {
      [this.sliderMin, this.sliderMax] = [this.sliderMax, this.sliderMin];
    }

    this.min_market_cap = this.sliderMin * 1e6;
    this.max_market_cap = this.sliderMax * 1e6;

    this.minCapInput = this.formatCap(this.min_market_cap);
    this.maxCapInput = this.formatCap(this.max_market_cap);
  }


  onConfirm() {
    // console.log(this.minCapInput,this.maxCapInput);
    const parsedMin = this.parseCapValue(this.minCapInput) ?? 0;
    const parsedMax = this.parseCapValue(this.maxCapInput) ?? 0;

    const [min, max] = parsedMin > parsedMax ? [parsedMax, parsedMin] : [parsedMin, parsedMax];

    this.dialogRef.close({ min, max });
  }

  enforceMinMax() {
    if (this.sliderMin > this.sliderMax) {
      [this.sliderMin, this.sliderMax] = [this.sliderMax, this.sliderMin];
    }
  }
}
